import { connect } from "react-redux";
import { getCLIList, loadingData } from "actions/client/cli";

import CLI from "./CLI";

const mapState = ({ auth_dialer, client_cli }) => ({

    count: client_cli.count,
    cliList: client_cli.items,
    cliLoading: client_cli.loading,
    service: auth_dialer.serviceDialer,
    //accountJoinList: auth_dialer.accountJoinList,
    //dialerInfo: auth_dialer.dialerInfo,
    // page: client_cli.page,
    // per_page: client_cli.per_page
});

export default connect(mapState, {
    getCLIList
})(CLI);